import { useEffect } from 'react';
import type { TechnicalCapacityResponse } from 'src/apis/capacity-management/types';
import type { CmNetworkPointRequest } from 'src/apis/capacity-management/use-cm-network-point';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  cmNetworkPoint: CmNetworkPointRequest;
};

type RequestOptions = {
  url: string;
};

export function useTechnicalCapacity({ cmNetworkPoint }: HookConfig) {
  const technicalCapacity = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<TechnicalCapacityResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );
  useEffect(() => {
    if (!cmNetworkPoint.response) return;

    const url = cmNetworkPoint.response.data._links.viewTechnicalCapacity.href;
    const options = { url };

    technicalCapacity.execute(options);
    // oxlint-disable-next-line exhaustive-deps
  }, [cmNetworkPoint.response]);

  return technicalCapacity;
}

export type TechnicalCapacityRequest = ReturnType<typeof useTechnicalCapacity>;
